import asyncComponent from './utils/AsyncComponent';
 

const CyyBigScreen = asyncComponent(() => import("./pages/cyyBigScreen"));

export const privateRoutes = [
    {},

    // {
    //     path: '/c',
    //     component: Company,
    //     exact: true
    // },
    // {
    //     path: '/user',
    //     component: UserCreate,
    //     exact: true
    // },
    // {
    //     path: '/userbind',
    //     component: userBind,
    //     exact: true
    // },
    // {
    //     path: '/home',
    //     component: UserHome,
    //     exact: true
    // },

    // {
    //     path: '/company/:step',
    //     component: CompanyCreate,

    // },

    // {
    //     path: '/app/:company_id',
    //     component: CompanyApp
    // },

];

export const publicRoutes = [
    {
        path: '/',
        component: CyyBigScreen,
        exact: true
    },
    // {
    //     path: '/login',
    //     component: Login,
    //     exact: true
    // },
    // {
    //     path: '/register',
    //     component: Register,
    //     exact: true
    // },
    // {
    //     path: '/forgotpassword',
    //     component: ForgotPassword
    // },
    // {
    //     path: '/resetpassword',
    //     component: ResetPassword
    // },
    // {
    //     path: '/qjcy',
    //     component: ViewHome
    // },
    {
        path: '/view',
        component: CyyBigScreen
    },

];



